import TabsNavContainer from "components/shared/TabsNavContainer";
import TabLink from "hardcover-ui/components/TabLink";
import { PageSerializersSeriesShow } from "types/serializers";

export default function SeriesTabBar({
  series,
}: {
  series: PageSerializersSeriesShow;
}) {
  // Don't show tabs if there are no collections
  if (series.collectionsCount === 0) {
    return <></>;
  }

  return (
    <TabsNavContainer>
      <TabLink href={`/series/${series.slug}`}>
        <>Books</>
      </TabLink>
      <TabLink href={`/series/${series.slug}/collections`}>
        <>Collections</>
      </TabLink>
    </TabsNavContainer>
  );
}
